export default "__VITE_ASSET__Bcclfp1D__"